(() => {
  const script = document.currentScript;
  const label = script?.dataset?.bookLabel || 'Book your repair here';

  const enhanceRepairMenus = () => {
    document.querySelectorAll('.t4s-menu-item-has-children').forEach((menuItem) => {
      const parentLink = menuItem.querySelector(':scope > a');
      if (!parentLink || parentLink.textContent.trim().toLowerCase() !== 'repairs') return;

      const submenu = menuItem.querySelector(':scope > .t4s-sub-menu');
      if (!submenu) return;

      const repairLinks = [...submenu.querySelectorAll('a')];
      const ninebotLink = repairLinks.find((link) => link.textContent.trim().toLowerCase() === 'ninebot repairs ireland');
      const segwayLink = repairLinks.find((link) => link.textContent.trim().toLowerCase() === 'segway repairs ireland');

      if (ninebotLink) {
        ninebotLink.textContent = 'Ninebot Segway Repairs Ireland';
        ninebotLink.href = '/pages/ninebot-segway-electric-scooter-repairs-ireland';
      } else if (segwayLink) {
        segwayLink.textContent = 'Ninebot Segway Repairs Ireland';
        segwayLink.href = '/pages/ninebot-segway-electric-scooter-repairs-ireland';
      }

      if (ninebotLink && segwayLink) segwayLink.closest('li')?.remove();

      if (submenu.querySelector('[data-lifty-repair-booking-link]')) return;

      const item = document.createElement('li');
      item.className = 't4s-menu-item t4s-item-level-1 lifty-repair-menu-booking';
      item.dataset.liftyRepairBookingLink = '';

      const link = document.createElement('a');
      link.href = '/collections/electric-scooter-repairs-dublin-lifty-electric#lifty-repair-services';
      link.textContent = label;
      item.append(link);
      submenu.prepend(item);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceRepairMenus, { once: true });
  } else {
    enhanceRepairMenus();
  }
  document.addEventListener('shopify:section:load', enhanceRepairMenus);
})();
